/** Shared, server-backed recovery for a fog prerequisite (held words, first looks and Your turn). */
import { html } from 'lit';
import { t } from './i18n';
import { go } from './router';
import type { LearnStatus } from './types';

/** A route appears only when the last server read says a first look or backlog work can help. */
export function roundRecovery(status: LearnStatus | undefined, checked: boolean, failed = false) {
  const route = (e: Event) => { e.preventDefault(); go('/round'); };
  return html`<div class="learning-recovery" role="note">
    ${!checked
      ? html`<span>${t('learning.roundChecking')}</span>`
      : failed || !status
        ? html`<span>${t('learning.roundUnavailable')}</span>`
        : status.round?.canProgressFog
          ? html`<a class="btn ghost small" href="/round" @click=${route}>${t('learning.roundNext')}</a>`
          : html`<span>${t('learning.roundWait')}</span>`}
  </div>`;
}
